"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lat2y_1 = require("./lat2y");

var lng2x_1 = require("./lng2x");
/**
 * Transforms latitude and longitude with a z value of a tile coordinate to its corresponding tile coordinate.
 */


function latLng2tileCoordinates(latLng, z) {
  return {
    x: lng2x_1.lng2x(latLng.lng, z),
    y: lat2y_1.lat2y(latLng.lat, z),
    z: z
  };
}

exports.latLng2tileCoordinates = latLng2tileCoordinates;